// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\na[data-v-7fdc93ea], a[data-v-7fdc93ea]:visited, a[data-v-7fdc93ea]:hover, a[data-v-7fdc93ea]:active {\n  color: inherit;\n}\n", ""]);
// Exports
module.exports = exports;
